import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import { ManagementLdsConnectionModel, ManagementUpdateLdsConnectionModel } from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class LdsConnectionsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params: PaginationSearchModel,
    isShowLoader: boolean = true,
  ): Observable<PaginatedResultModel<ManagementLdsConnectionModel>> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/management/lds-connections`, { params }, { isShowLoader });
  }

  public get(id: number, isShowLoader: boolean = true): Observable<ManagementLdsConnectionModel> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/management/lds-connections/${id}`, null, { isShowLoader });
  }

  public update(
    id: number,
    data: ManagementUpdateLdsConnectionModel,
    isShowLoader: boolean = true,
  ): Observable<ManagementLdsConnectionModel> {
    return this.apiService.put(`${environment.url.prefixCustoms}v2/management/lds-connections/${id}`, data, null, { isShowLoader });
  }

  public locationsSynchronization(id: number, isShowLoader: boolean = true): Observable<ManagementLdsConnectionModel> {
    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/management/lds-connections/${id}/locations-synchronizations`,
      {},
      null,
      { isShowLoader },
    );
  }
}
